'use strict';

import { createElement, appendElementContent } from '@jspartials/dom-api-utils';

// Selectors
const selector = {
  foursixty: {
    carousel: '.js-foursixty',
    timeline: '.fs-wrapper'
  }
};

// Elements
let foursixtyCarousel = null;
let foursixtyTimeline = null;

// Functions

const initFoursixty = () => {
  foursixtyCarousel =
    document.querySelector(selector.foursixty.carousel) || null;
  foursixtyTimeline =
    document.querySelector(selector.foursixty.timeline) || null;

  if (foursixtyCarousel) {
    clearFoursixty();
    const foursixtyScript = createFoursixtyScript();
    appendElementContent(foursixtyCarousel, foursixtyScript);
  }
};

const clearFoursixty = () => {
  foursixtyCarousel.innerHTML = '';

  if (foursixtyTimeline) {
    foursixtyTimeline.innerHTML = '';
  }
};

const createFoursixtyScript = () => {
  return createElement({
    tag: 'script',
    attributes: [
      {
        name: 'async',
        value: true
      },
      {
        name: 'src',
        value: foursixtyCarousel.dataset.src
      },
      {
        name: 'data-feed-id',
        value: foursixtyCarousel.dataset.feedId
      },
      {
        name: 'data-for-url',
        value: foursixtyCarousel.dataset.forUrl
      },
      {
        name: 'data-open-links-in-same-page',
        value: foursixtyCarousel.dataset.openLinksInSamePage
      },
      {
        name: 'data-theme',
        value: foursixtyCarousel.dataset.theme
      },
      {
        name: 'data-cell-size',
        value: foursixtyCarousel.dataset.cellSize
      }
    ]
  });
};

export { initFoursixty };
